import { Component, OnInit, Inject, ViewEncapsulation, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { CoreService } from 'src/app/core/helpers/core.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'loyaltic-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InfoComponent implements OnInit, OnDestroy {
  UserName = '';
  adminLock = true;
  @ViewChild('emailReminderTemplate', { static: false }) emailReminderTemplate?: TemplateRef<any>;
  modalRef?: BsModalRef;
  reminderModalConfig = {
    class: 'lyltc modal-md modal-dialog-centered',
    ignoreBackdropClick: true,
  };

  constructor(@Inject('ImagePath') public ImagePath,
    private coreService: CoreService, private toast: ToastrService,
    public translate: TranslateService, private modalService: BsModalService) { }

  ngOnInit() {
    if (window.location.pathname === "/admin") {
      this.adminLock = false;
    }
  }

  ngOnDestroy(): void {
    this.modalRef?.hide();
  }

  onSubmit(form) {
    this.coreService.signUp(this.UserName).then((response: any) => {
      form.submitted = false;
      this.UserName = '';
      const messageKey = response.messageKey;
      this.toast.success(this.translate.instant('' + messageKey), this.translate.instant('success'));
    });
  }

  openEmailReminder(event: Event): void {
    event.preventDefault();
    if (!this.emailReminderTemplate) {
      return;
    }
    this.modalRef = this.modalService.show(this.emailReminderTemplate, this.reminderModalConfig);
  }

}
